import { Injectable } from '@angular/core';
import { Environment } from '../interfaces/environment';
import { environmentName } from '../globals';

@Injectable()
export default class EnvironmentService implements Environment {

  private environmentName: string = environmentName;
  private hostname: string = window.location.hostname;
  private port = this.isDevelopment ? ':5001' : '';
  private crimWebVirtualDirectoryName = this.isDevelopment ? '' : '/crimwebapi';
  private protocol = window.location.protocol;

  get webApiUrl(): string {
    return `${this.protocol}//${this.hostname}${this.port}${this.crimWebVirtualDirectoryName}/api/`;
  }

  get loginUrl(): string {
    return `${this.webApiUrl}account/login`;
  }
  get cacheControlKeyUrl(): string {
    return `${this.webApiUrl}ConfigurationKey/SwitchStatus?`;
  }
  get resetUrl(): string {
    return `${this.webApiUrl}account/Forgot`;
  }

  get logoutUrl(): string {
    return `${this.webApiUrl}account/logout`;
  }

  get changePasswordUrl(): string {
    return `${this.webApiUrl}account/Change`;
  }

  get registerUrl(): string {
    return `${this.webApiUrl}account/create`;
  }

  get helloWorldUrl(): string {
    return `${this.webApiUrl}helloworld/1`;
  }

  get navigationUrl(): string {
    return `${this.webApiUrl}NavigationPage `;
  }

  get taskListUrl(): string {
    return `${this.webApiUrl}Requests?`;
  }

  get jurisdictionUrl(): string {
    return `${this.webApiUrl}Jurisdictions`;
  }

  get markRequestReceivedUrl(): string {
    return `${this.webApiUrl}Requests/MarkReceived`;
  }

  get GetWorkOrdersUrl(): string {
    return `${this.webApiUrl}Requests/GetWorkOrders`;
  }

  get getResearchTaskCommentUrl(): string {
    return `${this.webApiUrl}RequestComments?`;
  }
  get checkAuthorizationtUrl(): string {
    return `${this.webApiUrl}BrowserSecurity/CheckAuthorization?`;
  }
  get getSubmitTasklUrl(): string {
    return `${this.webApiUrl}Requests/SubmitChanges`;
  }

  get SpecialInstructionUrl(): string {
    return `${this.webApiUrl}SpecialInstructions?`;
  }

  get saveResearchTaskCommentUrl(): string {
    return `${this.webApiUrl}RequestComments/AddComment`;
  }

  get deleteResearchTaskCommentUrl(): string {
    return `${this.webApiUrl}RequestComments/DeleteComment`;
  }

  get getOffenses(): string {
    return `${this.webApiUrl}request`;
  }

  get deleteOffense(): string {
    return `${this.webApiUrl}request/delete`;
  }

  get saveOffenses(): string {
    return `${this.webApiUrl}offenses/save`;
  }

  get workOrderComplete(): string {
    return `${this.webApiUrl}Request/workOrderComplete`;
  }

  get invoiceUrl(): string {
    return `${this.webApiUrl}invoice`;
  }

  get complianceAuditLogs(): string {
    return `${this.webApiUrl}ComplianceAuditLog/add`;
  }

  get isDevelopment(): boolean {
    return this.environmentName === 'DEVELOPMENT';
  }

  get isProduction(): boolean {
    return this.environmentName === 'PRODUCTION';
  }
}



// WEBPACK FOOTER //
// ./src/services/environmentService.ts